import apiClient from '../../../services/api-client'
import type { SurveyConfig, CreateSurveyRequest, UpdateSurveyRequest, ListSurveysResponse } from '../types/survey.types'

export async function listSurveys(): Promise<SurveyConfig[]> {
  const response = await apiClient.get<ListSurveysResponse>('/survey')
  return response.data.data
}

export async function getSurvey(id: string): Promise<SurveyConfig> {
  const response = await apiClient.get<SurveyConfig>(`/survey/${id}`)
  return response.data
}

export async function createSurvey(request: CreateSurveyRequest): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/survey', request)
  return response.data
}

export async function updateSurvey(id: string, request: UpdateSurveyRequest): Promise<void> {
  await apiClient.put(`/survey/${id}`, { id, ...request })
}

export async function deleteSurvey(id: string): Promise<void> {
  await apiClient.delete(`/survey/${id}`)
}
